module.exports = __webpack_public_path__ + "img/08.556bced4.png";